module.exports = __webpack_public_path__ + "static/media/xmas-cropped.ccd0b04c.png";